import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRules = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5936 6.50875H8.96738L10.4063 1L3.40625 9.49125H7.0325L5.59362 15L12.5936 6.50875Z",
		stroke: "currentColor",
		strokeLinejoin: "round"
	})
});
export default SvgRules;
